import baseAPI from '@/api/base';
import { EditEmployeeLeave, GetEmployeeLeave, RegisterEmployeeLeave } from '@/dtos/employee_leave.dto';
import {
  APPROVE_EMPLOYEE_LEAVE_IS_ACTIVE_URL,
  CANCEL_EMPLOYEE_LEAVE_IS_ACTIVE_URL,
  DELETE_EMPLOYEE_LEAVE_URL,
  EDIT_EMPLOYEE_LEAVE_URL,
  GET_EMPLOYEE_LEAVE_URL,
  REGISTER_EMPLOYEE_LEAVE_URL,
  REJECT_EMPLOYEE_LEAVE_IS_ACTIVE_URL,
  TOGGLE_EMPLOYEE_LEAVE_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class EmployeeLeave {
  static getEmployeeLeaves = async (getEmployeeLeave: GetEmployeeLeave): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EMPLOYEE_LEAVE_URL, {
      params: getEmployeeLeave,
    });
    console.log('response', response);
    return response;
  };

  static registerEmployeeLeave = async (
    registerEmployeeLeave: RegisterEmployeeLeave
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_EMPLOYEE_LEAVE_URL, {
      ...registerEmployeeLeave,
    });
    console.log('response', response);
    return response;
  };

  static editEmployeeLeave = async (editEmployeeLeave: EditEmployeeLeave): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_EMPLOYEE_LEAVE_URL, {
      ...editEmployeeLeave,
    });
    return response;
  };

  static toggleEmployeeLeaveIsActive = async (
    editEmployeeLeave: EditEmployeeLeave
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_EMPLOYEE_LEAVE_IS_ACTIVE_URL,
      {
        ...editEmployeeLeave,
      }
    );
    return response;
  };

  static approveEmployeeLeave = async (
    editEmployeeLeave: EditEmployeeLeave
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      APPROVE_EMPLOYEE_LEAVE_IS_ACTIVE_URL,
      {
        ...editEmployeeLeave,
      }
    );
    return response;
  };

  static rejectEmployeeLeave = async (
    editEmployeeLeave: EditEmployeeLeave
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      REJECT_EMPLOYEE_LEAVE_IS_ACTIVE_URL,
      {
        ...editEmployeeLeave,
      }
    );
    return response;
  };

  static cancelEmployeeLeave = async (
    editEmployeeLeave: EditEmployeeLeave
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      CANCEL_EMPLOYEE_LEAVE_IS_ACTIVE_URL,
      {
        ...editEmployeeLeave,
      }
    );
    return response;
  };

  static deleteEmployeeLeave = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_EMPLOYEE_LEAVE_URL}/${userId}`
    );
    return response;
  };
}

export default EmployeeLeave;
